import React from 'react';

import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, Icon, Typography } from '@material-ui/core';

import * as ActionsDialog from 'app/store/actions';

const ErrorDialog = props => {
	const dispatch = useDispatch();

	const handleClose = () => {
		if (props.clearError) {
			props.clearError();
		}
		dispatch(ActionsDialog.closeDialog());
	};

	const title = props.title || 'Something went wrong';

	return (
		<React.Fragment>
			<DialogTitle disableTypography className="flex items-center">
				{!props.title && <Icon className="text-red mr-8">error_outline</Icon>}
				<Typography variant="h6" className="font-semibold">
					{title}
				</Typography>
			</DialogTitle>
			<DialogContent id="err-msg">
				<Typography color="textSecondary" component="div">
					{props.message}
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button id="err-acknowlege" onClick={() => handleClose()} variant="outlined">
					Close
				</Button>
			</DialogActions>
		</React.Fragment>
	);
};

export default ErrorDialog;
